"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => ({
    button: {
        fontSize: 14,
        textAlign: 'left',
        backgroundColor: 'inherit',
        border: 'none',
        cursor: 'pointer',
        outline: 'none',
        padding: 0
    }
});
//# sourceMappingURL=button.style.js.map